import * as yup from 'yup';
import { CTAGroup } from '@web/components';
import { schema as ctaButtonSchema } from './cta_button';

export const component = CTAGroup;

export const schema = yup
  .object({
    component: yup.string(),
    ctas: yup.array(ctaButtonSchema),
    buttonsPerRow: yup.number().nullable(),
    alignment: yup.string(),
    gap: yup.number().nullable(),
  })
  .transform(value => ({
    component: 'cta_group',
    ctas: value.ctas || [],
    buttonsPerRow: value.buttons_per_row || undefined,
    alignment: value.alignment || undefined,
    gap:
      value?.gap === null || value?.gap === '' || isNaN(Number(value?.gap))
        ? undefined
        : Number(value?.gap),
  }));
